import React, { useState } from 'react'
import _, { isEmpty } from 'lodash'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  InputNumber,
  Select,
  Tabs
} from 'antd'

import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'

const { TabPane } = Tabs

function parseFeaturesFromData(featuresRaw) {
  if (!featuresRaw) return {}
  if (typeof featuresRaw === 'object') return featuresRaw
  try {
    return JSON.parse(featuresRaw)
  } catch (e) {
    return {}
  }
}

const PackagesForm = (props) => {
  const { visible, onOk, onCancel, formData, tierOptions, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue, getFieldValue } =
    form
  const isEdit = !_.isEmpty(formData)

  const [watermarkValue, setWatermarkValue] = useState(null)
  const [sentEmailReportValue, setSentEmailReportValue] = useState(null)
  const [alertSettingValue, setAlertSettingValue] = useState(null)
  const [limitWeighingValue, setLimitWeighingValue] = useState(null)
  const [limitAccountingValue, setLimitAccountingValue] = useState(null)
  const [addonTargetValue, setAddonTargetValue] = useState('branch')
  const [activeTabKey, setActiveTabKey] = useState('main')
  const [pricingTypeValue, setPricingTypeValue] = useState('cycle')

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      var parsed = parseFeaturesFromData(formData.features)

      setFieldsValue({
        name: formData.name,
        detail: formData.detail,
        price: formData.price,
        maxPrice: formData.maxPrice,
        time: formData.time,
        deviceAvailable: formData.deviceAvailable,
        saveImageLongTime: formData.saveImageLongTime,
        remark: formData.remark,
        code: formData.code,
        tier: formData.tier,
        branchLimit: formData.branchLimit,
        priceMonthly: formData.priceMonthly,
        priceYearly: formData.priceYearly,
        featLimitWeighing:
          parsed.limitWeighing != null ? parsed.limitWeighing : undefined,
        featLimitAccounting:
          parsed.limitAccounting != null ? parsed.limitAccounting : undefined
      })

      if (parsed.watermarkRemoved !== undefined) {
        setWatermarkValue(parsed.watermarkRemoved ? 'show' : 'hide')
      } else {
        setWatermarkValue(null)
      }
      if (parsed.sentEmailReport !== undefined) {
        setSentEmailReportValue(parsed.sentEmailReport ? 'show' : 'hide')
      } else {
        setSentEmailReportValue(null)
      }
      if (parsed.alertSetting !== undefined) {
        setAlertSettingValue(parsed.alertSetting ? 'show' : 'hide')
      } else {
        setAlertSettingValue(null)
      }
      parsed.limitWeighing === 0
        ? setLimitWeighingValue('limitWeighingZero')
        : setLimitWeighingValue(null)
      parsed.limitAccounting === 0
        ? setLimitAccountingValue('limitAccountingZero')
        : setLimitAccountingValue(null)

      if (formData.deviceAvailable) {
        setAddonTargetValue('device')
      } else {
        setAddonTargetValue('branch')
      }

      setPricingTypeValue(
        formData.priceMonthly != null || formData.priceYearly != null
          ? 'cycle'
          : 'custom'
      )

      setActiveTabKey(formData.packageType === 'ADDON' ? 'extra' : 'main')
    } else {
      setWatermarkValue(null)
      setSentEmailReportValue(null)
      setAlertSettingValue(null)
      setLimitWeighingValue(null)
      setLimitAccountingValue(null)
      setAddonTargetValue('branch')
      setPricingTypeValue('cycle')
      setActiveTabKey('main')
    }

    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        let priceValue = values.price !== undefined ? values.price : null
        if (pricingTypeValue === 'cycle') {
          priceValue = values.priceMonthly
        }
        const data = {
          packageType: activeTabKey === 'extra' ? 'ADDON' : 'MAIN',
          name: values.name,
          detail: values.detail ? values.detail : null,
          price: priceValue,
          maxPrice: values.maxPrice,
          time: pricingTypeValue === 'cycle' ? 30 : values.time,
          deviceAvailable: values.deviceAvailable
            ? values.deviceAvailable
            : null,
          saveImageLongTime: values.saveImageLongTime
            ? values.saveImageLongTime
            : null,
          remark: values.remark ? values.remark : null,
          code: values.code ? values.code : null,
          tier: values.tier !== undefined ? values.tier : 'FREE',
          branchLimit:
            values.branchLimit !== undefined ? values.branchLimit : 0,
          priceMonthly:
            pricingTypeValue === 'custom' ? null : values.priceMonthly,
          priceYearly:
            pricingTypeValue === 'custom' ? null : values.priceYearly,
          features: (() => {
            var feat = {}
            if (watermarkValue === 'show') feat.watermarkRemoved = true
            if (sentEmailReportValue === 'show') feat.sentEmailReport = true
            if (alertSettingValue === 'show') feat.alertSetting = true
            if (limitWeighingValue === 'limitWeighingZero') {
              feat.limitWeighing = 0
            } else if (values.featLimitWeighing != null) {
              feat.limitWeighing = values.featLimitWeighing
            }
            if (limitAccountingValue === 'limitAccountingZero') {
              feat.limitAccounting = 0
            } else if (values.featLimitAccounting != null) {
              feat.limitAccounting = values.featLimitAccounting
            }
            return Object.keys(feat).length > 0 ? JSON.stringify(feat) : null
          })()
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }

  return (
    <Modal
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a Package`}
      visible={visible}
      footer={null}
      onCancel={onCancel}
      width={600}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Tabs
          activeKey={activeTabKey}
          onChange={(key) => {
            form.resetFields()
            setWatermarkValue(null)
            setSentEmailReportValue(null)
            setAlertSettingValue(null)
            setLimitWeighingValue(null)
            setLimitAccountingValue(null)
            setAddonTargetValue('branch')
            setPricingTypeValue('cycle')
            setActiveTabKey(key)
            if (key === 'extra') {
              setFieldsValue({ branchLimit: 1 })
            }
          }}>
          {(!isEdit || activeTabKey === 'main') && (
            <TabPane tab="แพ็กเกจหลัก" key="main">
              <Form.Item label="ชื่อแพ็กเกจ">
                {getFieldDecorator(`name`, {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณากรอก'
                    }
                  ]
                })(<Input name="name" placeholder="ชื่อแพ็กเกจ" />)}
              </Form.Item>
              <Form.Item label="รายละเอียดแพ็กเกจ">
                {getFieldDecorator(`detail`)(
                  <Input.TextArea name="name" placeholder="รายละเอียด" />
                )}
              </Form.Item>
              <Form.Item label="ประเภทราคา">
                <Radio.Group
                  value={pricingTypeValue}
                  disabled={isEdit}
                  onChange={(e) => setPricingTypeValue(e.target.value)}>
                  <Radio value="cycle">ตามรอบบิล</Radio>
                  <Radio value="custom">กำหนดเอง</Radio>
                </Radio.Group>
              </Form.Item>
              {pricingTypeValue === 'custom' && (
                <Row gutter={8}>
                  <Col span={12}>
                    <Form.Item label="ราคาแพ็กเกจ">
                      {getFieldDecorator(`price`, {
                        initialValue: !isEmpty(formData)
                          ? formData.price
                          : undefined,
                        rules: [
                          {
                            required: true,
                            message: 'กรุณากรอก'
                          }
                        ]
                      })(
                        <InputNumber
                          name="name"
                          placeholder="ราคาแพ็กเกจ"
                          style={{ width: '100%' }}
                          min={0}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="ราคาแพ็กเกจเต็ม">
                      {getFieldDecorator(`maxPrice`, {
                        rules: [
                          {
                            required: true,
                            message: 'กรุณากรอก'
                          }
                        ]
                      })(
                        <InputNumber
                          name="name"
                          placeholder="ราคาเต็ม"
                          style={{ width: '100%' }}
                          min={0}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              )}
              {pricingTypeValue === 'cycle' && (
                <React.Fragment>
                  <Row gutter={8}>
                    <Col span={12}>
                      <Form.Item label="ราคา/เดือน">
                        {getFieldDecorator(`priceMonthly`, {
                          initialValue: !isEmpty(formData)
                            ? formData.priceMonthly
                            : undefined,
                          rules: [
                            {
                              required: true,
                              message: 'กรุณากรอก'
                            }
                          ]
                        })(
                          <InputNumber
                            placeholder="ราคารายเดือน"
                            style={{ width: '100%' }}
                            min={0}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="ราคา/ปี">
                        {getFieldDecorator(`priceYearly`, {
                          initialValue: !isEmpty(formData)
                            ? formData.priceYearly
                            : undefined,
                          rules: [
                            {
                              required: true,
                              message: 'กรุณากรอก'
                            }
                          ]
                        })(
                          <InputNumber
                            placeholder="ราคารายปี"
                            style={{ width: '100%' }}
                            min={0}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item label="ราคาแพ็กเกจเต็ม">
                    {getFieldDecorator(`maxPrice`, {
                      rules: [
                        {
                          required: true,
                          message: 'กรุณากรอก'
                        }
                      ]
                    })(
                      <InputNumber
                        name="name"
                        placeholder="ราคาเต็ม"
                        style={{ width: '100%' }}
                        min={0}
                      />
                    )}
                  </Form.Item>
                </React.Fragment>
              )}
              {pricingTypeValue === 'custom' && (
                <Form.Item label="ระยะเวลาแพ็กเกจ (วัน)">
                  {getFieldDecorator(`time`, {
                    rules: [
                      {
                        required: true,
                        message: 'กรุณากรอก'
                      }
                    ]
                  })(
                    <InputNumber
                      name="name"
                      placeholder="จำนวนวันที่แพ็กเกจมีผลใช้งาน"
                      style={{ width: '100%' }}
                      min={0}
                    />
                  )}
                </Form.Item>
              )}
              <Form.Item label="จำนวนเพิ่มเครื่องใช้งาน">
                {getFieldDecorator(`deviceAvailable`)(
                  <InputNumber
                    name="name"
                    placeholder="กรอกจำนวนเครื่องที่จะเพิ่มเมื่อมีการใช้งานแพ็กเกจ ถ้าไม่กรอกข้อมูลจะเท่ากับ 0"
                    style={{ width: '100%' }}
                    min={0}
                  />
                )}
              </Form.Item>
              <Form.Item label="ระยะเวลาเก็บรูป (วัน)">
                {getFieldDecorator(`saveImageLongTime`)(
                  <InputNumber
                    name="name"
                    placeholder="กรอกจำนวนวัน ถ้าไม่กรอกข้อมูลจะเท่ากับ 0"
                    style={{ width: '100%' }}
                    min={0}
                  />
                )}
              </Form.Item>
              <Form.Item label="Remark">
                {getFieldDecorator(`remark`)(
                  <Input name="name" placeholder="หมายเหตุ" />
                )}
              </Form.Item>

              {/* <Form.Item label="Bundle Code (ปล่อยว่าง = แพ็กเกจ à-la-carte เดิม)">
                {getFieldDecorator(`code`)(
                  <Select placeholder="เลือก bundle code" allowClear>
                    <Select.Option value="FREE">FREE</Select.Option>
                    <Select.Option value="STARTER">STARTER</Select.Option>
                    <Select.Option value="SMART_PRO">SMART_PRO</Select.Option>
                    <Select.Option value="PRO_MAX">PRO_MAX</Select.Option>
                  </Select>
                )}
              </Form.Item> */}
              <Form.Item label="Tier">
                {getFieldDecorator(`tier`, {
                  rules: [
                    {
                      required: activeTabKey === 'main',
                      message: 'กรุณากรอก'
                    }
                  ]
                })(
                  <Select placeholder="เลือก tier" allowClear>
                    {(tierOptions || []).map((tier) => (
                      <Select.Option key={tier} value={tier}>
                        {tier}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="จำนวนเพิ่มสาขาที่รวมในแพ็กเกจ">
                {getFieldDecorator(`branchLimit`, {
                  rules: [
                    {
                      required: activeTabKey === 'main',
                      message: 'กรุณากรอก'
                    }
                  ]
                })(
                  <InputNumber
                    placeholder="0"
                    style={{ width: '100%' }}
                    min={0}
                  />
                )}
              </Form.Item>
              {/* moved to TierFeature form
              <Form.Item label="จำกัดการทำรายการชั่ง">
                {getFieldDecorator(`featLimitWeighing`)(
                  <InputNumber
                    placeholder="กรอกตัวเลขจำนวนเต็ม"
                    style={{ width: '40%' }}
                    min={0}
                    disabled={limitWeighingValue === 'limitWeighingZero'}
                  />
                )}
                <Checkbox
                  style={{ marginLeft: '10px' }}
                  checked={limitWeighingValue === 'limitWeighingZero'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setFieldsValue({ featLimitWeighing: 0 })
                      setLimitWeighingValue('limitWeighingZero')
                    } else {
                      setLimitWeighingValue(null)
                    }
                  }}>
                  ไม่จำกัดการทำรายการชั่ง
                </Checkbox>
              </Form.Item>
              <Form.Item label="จำกัดการทำรายการบัญชี">
                {getFieldDecorator(`featLimitAccounting`)(
                  <InputNumber
                    placeholder="กรอกตัวเลขจำนวนเต็ม"
                    style={{ width: '40%' }}
                    min={0}
                    disabled={limitAccountingValue === 'limitAccountingZero'}
                  />
                )}
                <Checkbox
                  style={{ marginLeft: '10px' }}
                  checked={limitAccountingValue === 'limitAccountingZero'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setFieldsValue({ featLimitAccounting: 0 })
                      setLimitAccountingValue('limitAccountingZero')
                    } else {
                      setLimitAccountingValue(null)
                    }
                  }}>
                  ไม่จำกัดการทำรายการบัญชี
                </Checkbox>
              </Form.Item>
              <Form.Item label="แสดงลายน้ำในบิลและเอกสาร">
                <Radio.Group
                  value={watermarkValue}
                  onChange={(e) => setWatermarkValue(e.target.value)}>
                  <Radio value="show">แสดงลายน้ำ</Radio>
                  <Radio value="hide">ไม่แสดงลายน้ำ</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item label="ส่งอีเมลรายงานยอดขายประจำวัน">
                <Radio.Group
                  value={sentEmailReportValue}
                  onChange={(e) => setSentEmailReportValue(e.target.value)}>
                  <Radio value="show">ส่งรายงานประจำวัน</Radio>
                  <Radio value="hide">ไม่ส่งรายงานประจำวัน</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item label="เปิดการตั้งค่าศูนย์แจ้งเตือน">
                <Radio.Group
                  value={alertSettingValue}
                  onChange={(e) => setAlertSettingValue(e.target.value)}>
                  <Radio value="show">เปิดการตั้งค่าศูนย์การแจ้งเตือน</Radio>
                  <Radio value="hide">ปิดการตั้งค่าศูนย์การแจ้งเตือน</Radio>
                </Radio.Group>
              </Form.Item> */}
            </TabPane>
          )}
          {(!isEdit || activeTabKey === 'extra') && (
            <TabPane tab="แพ็กเกจเสริม" key="extra">
              <Form.Item label="ชื่อแพ็กเกจ">
                {getFieldDecorator(`name`, {
                  rules: [
                    {
                      required: true,
                      message: 'กรุณากรอก'
                    }
                  ]
                })(<Input name="name" placeholder="ชื่อแพ็กเกจ" />)}
              </Form.Item>
              <Form.Item label="รายละเอียดแพ็กเกจ">
                {getFieldDecorator(`detail`)(
                  <Input.TextArea name="name" placeholder="รายละเอียด" />
                )}
              </Form.Item>
              <Form.Item label="ประเภทแพ็กเกจเสริม">
                <Radio.Group
                  value={addonTargetValue}
                  onChange={(e) => {
                    const v = e.target.value
                    setAddonTargetValue(v)
                    if (v === 'branch') {
                      setFieldsValue({
                        deviceAvailable: undefined,
                        branchLimit: getFieldValue('branchLimit') || 1
                      })
                    } else if (v === 'device') {
                      setFieldsValue({
                        branchLimit: undefined,
                        deviceAvailable: getFieldValue('deviceAvailable') || 1
                      })
                    }
                  }}>
                  <Radio value="branch">เพิ่มสาขา</Radio>
                  <Radio value="device">เพิ่มเครื่อง</Radio>
                </Radio.Group>
              </Form.Item>
              {addonTargetValue === 'branch' && (
                <Form.Item label="จำนวนสาขาที่รวมในแพ็กเกจ">
                  {getFieldDecorator(`branchLimit`, {
                    rules: [
                      {
                        required: true,
                        message: 'กรุณากรอก'
                      }
                    ]
                  })(
                    <InputNumber
                      placeholder="0"
                      style={{ width: '100%' }}
                      min={0}
                    />
                  )}
                </Form.Item>
              )}
              {addonTargetValue === 'device' && (
                <Form.Item label="จำนวนเครื่องใช้งาน">
                  {getFieldDecorator(`deviceAvailable`, {
                    rules: [
                      {
                        required: true,
                        message: 'กรุณากรอก'
                      }
                    ]
                  })(
                    <InputNumber
                      name="name"
                      placeholder="กรอกจำนวนเครื่องที่จะเพิ่มเมื่อมีการใช้งานแพ็กเกจ ถ้าไม่กรอกข้อมูลจะเท่ากับ 0"
                      style={{ width: '100%' }}
                      min={0}
                    />
                  )}
                </Form.Item>
              )}
              <Form.Item label="ประเภทราคา">
                <Radio.Group
                  value={pricingTypeValue}
                  disabled={isEdit}
                  onChange={(e) => setPricingTypeValue(e.target.value)}>
                  <Radio value="cycle">ตามรอบบิล</Radio>
                  <Radio value="custom">กำหนดเอง</Radio>
                </Radio.Group>
              </Form.Item>
              {pricingTypeValue === 'custom' && (
                <Row gutter={8}>
                  <Col span={12}>
                    <Form.Item label="ราคาแพ็กเกจ">
                      {getFieldDecorator(`price`, {
                        initialValue: !isEmpty(formData)
                          ? formData.price
                          : undefined,
                        rules: [
                          {
                            required: true,
                            message: 'กรุณากรอก'
                          }
                        ]
                      })(
                        <InputNumber
                          name="name"
                          placeholder="ราคาแพ็กเกจ"
                          style={{ width: '100%' }}
                          min={0}
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="ราคาแพ็กเกจเต็ม">
                      {getFieldDecorator(`maxPrice`, {
                        rules: [
                          {
                            required: true,
                            message: 'กรุณากรอก'
                          }
                        ]
                      })(
                        <InputNumber
                          name="name"
                          placeholder="ราคาเต็ม"
                          style={{ width: '100%' }}
                          min={0}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              )}
              {pricingTypeValue === 'cycle' && (
                <React.Fragment>
                  <Row gutter={8}>
                    <Col span={12}>
                      <Form.Item label="ราคา/เดือน">
                        {getFieldDecorator(`priceMonthly`, {
                          initialValue: !isEmpty(formData)
                            ? formData.priceMonthly
                            : undefined,
                          rules: [
                            {
                              required: true,
                              message: 'กรุณากรอก'
                            }
                          ]
                        })(
                          <InputNumber
                            placeholder="ราคารายเดือน"
                            style={{ width: '100%' }}
                            min={0}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="ราคา/ปี">
                        {getFieldDecorator(`priceYearly`, {
                          initialValue: !isEmpty(formData)
                            ? formData.priceYearly
                            : undefined,
                          rules: [
                            {
                              required: true,
                              message: 'กรุณากรอก'
                            }
                          ]
                        })(
                          <InputNumber
                            placeholder="ราคารายปี"
                            style={{ width: '100%' }}
                            min={0}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item label="ราคาแพ็กเกจเต็ม">
                    {getFieldDecorator(`maxPrice`, {
                      rules: [
                        {
                          required: true,
                          message: 'กรุณากรอก'
                        }
                      ]
                    })(
                      <InputNumber
                        name="name"
                        placeholder="ราคาเต็ม"
                        style={{ width: '100%' }}
                        min={0}
                      />
                    )}
                  </Form.Item>
                </React.Fragment>
              )}
              {pricingTypeValue === 'custom' && (
                <Form.Item label="ระยะเวลาแพ็กเกจ (วัน)">
                  {getFieldDecorator(`time`, {
                    rules: [
                      {
                        required: true,
                        message: 'กรุณากรอก'
                      }
                    ]
                  })(
                    <InputNumber
                      name="name"
                      placeholder="จำนวนวันที่แพ็กเกจมีผลใช้งาน"
                      style={{ width: '100%' }}
                      min={0}
                    />
                  )}
                </Form.Item>
              )}
              <Form.Item label="Remark">
                {getFieldDecorator(`remark`)(
                  <Input name="name" placeholder="หมายเหตุ" />
                )}
              </Form.Item>
            </TabPane>
          )}
        </Tabs>

        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedPackagesForm = Form.create({ name: 'PackagesForm' })(PackagesForm)
export default WrappedPackagesForm
